import { TextBasicAlignment, TextFont, TextResetColor, TextTransform, TextWrappingOverflow } from "../../../../src/examples/utilities/TextAlignment";
import * as React from 'react';
export default {
  TextBasicAlignment,
  TextFont,
  TextResetColor,
  TextTransform,
  TextWrappingOverflow,
  React
};